import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AppGlobals } from '@app/app.global';
import { AuthService, EntityService } from '@core/services';

@Injectable()
export class SecondaryOwnerProhibitedGuard implements CanActivate {
    companyDetail: any;
    redirectConfig = [
        {
            paths: ['/push-to-petpooja', '/push-to-petpooja/manage-invoice-tags'],
            requiredKey: 'restaurantSyncCode'
        },
        {
            paths: ['/push-to-retail-pos', '/push-to-retail-pos/manage-poss-tags'],
            requiredKey: 'retailPosSyncCode'
        },
        {
            paths: ['/push-to-tally', '/tally-config'],
            requiredKey: 'tallySyncCode'
        }
    ];

    constructor(
        private readonly router: Router,
        private readonly authService: AuthService,
        private readonly appGlobals: AppGlobals,
        private readonly entityService: EntityService
    ) {
        this.entityService.companyDetails$.subscribe((res) => {
            this.companyDetail = res;
        })
    }


    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authService.user?.isSecondaryOwner) {
            const currentURL = state.url;

            // If user is a Manager, grant access to all except Payments
            // if (this.authService.user?.isManager) {
            //     if (currentURL.includes('/payment') || currentURL.includes('/banking')) {
            //         this.router.navigate(['/dashboard']);
            //         return false;
            //     }
            //     return true;
            // }

            // For Employee role, check userAccessList
            const isAccess = this.appGlobals.userAccessList.find(access => access.regex.test(currentURL));

            if (isAccess?.name && this.authService.user.userAccessList.includes(isAccess.name)) {
                return true;
            } else {
                let fistURLAccessName;
                const userAccess = this.authService.user.userAccessList;
                const ACCESS = this.appGlobals.USER_ACCESS;

                switch (true) {

                    case userAccess.includes(ACCESS.DASHBAORD):
                        fistURLAccessName = ACCESS.DASHBAORD;
                        break;

                    case userAccess.includes(ACCESS.INVOICE_LISTING):
                        fistURLAccessName = ACCESS.INVOICE_LISTING;
                        break;

                    case userAccess.includes(ACCESS.TAG_MANAGEMENT):
                        fistURLAccessName = ACCESS.TAG_MANAGEMENT;
                        break;

                    case userAccess.includes(ACCESS.PAYMENTS):
                        fistURLAccessName = ACCESS.PAYMENTS;
                        break;

                    case userAccess.includes(ACCESS.PUSH_TO_PETPOOJA):
                        fistURLAccessName = ACCESS.PUSH_TO_PETPOOJA;
                        break;

                    case userAccess.includes(ACCESS.PATTY_EXPENSE):
                        fistURLAccessName = ACCESS.PATTY_EXPENSE;
                        break;

                    case userAccess.includes(ACCESS.REPORTS):
                        fistURLAccessName = ACCESS.REPORTS;
                        break;

                    case userAccess.includes(ACCESS.PURCHASE_MANAGER):
                        fistURLAccessName = ACCESS.PURCHASE_MANAGER;
                        break;

                    default:
                        fistURLAccessName = userAccess.find(access => access !== ACCESS.INVOICE_REVIEW);
                }

                const firstURL = this.appGlobals.userAccessList.find(
                    access => access.name === fistURLAccessName
                );

                this.router.navigate([firstURL?.url || '404']);
                return false;
            }
        } else {
            return this.waitForData().then(() => {
                const user = this.authService.user;
                const companyDetail = this.companyDetail;

                if (user?.isAdmin) {
                    return true;
                }

                const currentURL = state.url;

                const shouldRedirect = this.redirectConfig.some(config => {
                    return config.paths.includes(currentURL) && !(config.requiredKey in companyDetail);
                });

                if (shouldRedirect) {
                    this.router.navigate(['/dashboard']);
                    return false;
                }

                return true;
            });
        }
    }

    private waitForData(maxWaitMs = 5000, checkIntervalMs = 100): Promise<void> {
        return new Promise((resolve, reject) => {
            const start = Date.now();

            const interval = setInterval(() => {
                if (this.authService.user && this.companyDetail) {
                    clearInterval(interval);
                    resolve();
                } else if (Date.now() - start > maxWaitMs) {
                    clearInterval(interval);
                    console.warn('Timeout waiting for authService.user or companyDetail');
                    resolve();
                }
            }, checkIntervalMs);
        });
    }

}